import TEXT_1 from "../assets/noise/texts/100x800/100x800_PT01.gif";
import TEXT_2 from "../assets/noise/texts/100x800/100x800_PT2.gif";
import TEXT_3 from "../assets/noise/texts/100x800/100x800_PT3.gif";
import TITLE_1 from "../assets/noise/texts/MENU/WORK_SUB/WORK_SUB_1.gif";
import TITLE_2 from "../assets/noise/texts/MENU/WORK_SUB/WORK_SUB_2.gif";
import TITLE_3 from "../assets/noise/texts/MENU/WORK_SUB/WORK_SUB_3.gif";
import EMPTY from "../assets/noise/tabs/190723_NOISE_01_10.gif";

// reused animations for all text initialization
export const textAnimation = () => {
  const all = [TEXT_1, TEXT_2, TEXT_3];
  return all[Math.round(Math.random() * (all.length - 1))];
};
export const titleAnimation = () => {
  const all = [TITLE_1, TITLE_2, TITLE_3];
  return all[Math.round(Math.random() * (all.length - 1))];
};
export const EMPTY_GIF = EMPTY;

// dimension constants
export const PREVIEW_VIDEO_RESOLUTION = {
  height: 360,
  width: 640
};

export const VIDEO_RATIO_PC = 1.66;
export const VIDEO_RATIO_MOBILE = 1.9;

// controls the section divider lines
// as well as the container width per section
export const activeSectionWidthRatios = {
  work: {
    work: 0.66,
    team: 0.83
  },
  team: {
    work: 0.17,
    team: 0.83
  },
  about: {
    work: 0.17,
    team: 0.34
  },
  default: {
    work: 0.33,
    team: 0.66
  }
};

export const activeSectionHeightRatios = {
  default: {
    work: 0.33,
    team: 0.66
  }
};

// URLS
// -----
// // instance IPs on AWS lightsail
// const th_disco_development = "52.194.147.16"; //AWS DEV
// const th_disco_prod = "34.84.60.180"; //AWS PROD 35.75.78.17, need to replace it

// const private_ip = process.env.REACT_APP_DEV || th_disco_prod;
// console.log("private_ip:", private_ip);

// export const BASE_URL = `http://${private_ip}/wp-json/wp/v2`;

const getBaseUrl = () => {
  // If running in browser (not during build), use current domain
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/wp-json/wp/v2`;
  }

  // During build time
  if (process.env.NODE_ENV === 'production') {
    return 'https://www.disruptioncontents.tokyo/wp-json/wp/v2';
  }

  // Development
  const devUrl = process.env.REACT_APP_DEV || 'localhost:8000';
  return `http://${devUrl}/wp-json/wp/v2`;
};

export const BASE_URL = getBaseUrl();
export const FEATURED_MEDIA = "/media";

export const ENDPOINT_ABOUT = "/about";
export const ENDPOINT_TEAMS = "/teams";
export const ENDPOINT_WORKS = "/works";

export const TRANSITON_SPEED = {
  initial: { duration: 0.6 },
  default: { duration: 0.6 }
};
